import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { detectDeviceType, storeUsername, getPassCode, checkAdmin, getAllTravelDetail, resetOnlogout, setCurrentUser, checkApiError } from '../utils';
import { useAuth } from '../Context';
import { toast } from 'react-toastify';
import ImagesAll from '../assets';
import "./../css/login.css"

let isThisLoaded = false;

const Login = ({ toggleMenu, showLoading }) => {
    const { onLoginContext } = useAuth();
    const [username, setUsername] = useState('');
    const [isShowPwd, setIsShowPwd] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(true); // State for email validation
    const [passcodeError, setPasscodeError] = useState(''); // State for passcode error
    const [codeInputDis, setCodeInputDis] = useState(false);
    const [btnGetStateDis, setBtnGetStateDis] = useState(true);
    const [btnLoginStateDis, setBtnLoginStateDis] = useState(true);
    const [btnResendStateDis, setBtnResendStateDis] = useState(false);
    const [isUserLock, setIsUserLock] = useState(false);
    const navigate = useNavigate();

    const [timer, setTimer] = useState(0);

    useEffect(() => {
        if (timer > 0) {
          const interval = setInterval(() => {
            setTimer((prev) => prev - 1);
          }, 1000);
          return () => clearInterval(interval);
        } else {
            setBtnResendStateDis(false);
        }
      }, [timer]);

    useEffect(() => {
        toggleMenu(false);        
        if(!isThisLoaded){
            isThisLoaded = true;
            resetOnlogout();
            showLoading(false);
        }
    });

    const encryptStr = (str) => {
        //return str;
        str = makeid(6)+btoa(str);
        return str;
    }
    const makeid = (length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
    }

    const onGetCode = async (e) => {
        e.preventDefault();
        showLoading(true)
        onEmailVal();
        
        try{
            document.getElementById('username').disabled = true;
            setBtnGetStateDis(true);
            await fetch(`${process.env.REACT_APP_API_URL}/cab/regeneratepasscode`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': "*/*"
                },
                body: JSON.stringify({
                    "email": encryptStr(document.getElementById("username").value)
                })
            })
            .then(response => {
                if(checkApiError(response.status)){ navigate("/login"); return; }
                // Check if the response status is OK (200)
                if (response.ok) {
                    return response.json(); // Parse JSON response
                } else {
                    //throw new Error('Invalid passcode'); // Throw error for other status codes
                }
            })
            .then(data => {
                if(parseInt(data.isUserLock)){
                    // user lock for 2 min
                    setBtnResendStateDis(true);
                    setBtnLoginStateDis(true);
                    setIsUserLock(true);
                    setCodeInputDis(true);
                    document.getElementById('code').value = "";
                }else{
                    setUsername(document.getElementById("username").value);
                    storeUsername(document.getElementById("username").value);
                    setIsUserLock(false);
                    setBtnResendStateDis(true);
                    setCodeInputDis(false);
                    showLoading(false);
                    if (data.token) getPassCode(data.token.authToken);
                    toast.success("Passcode sent.");
                    setTimer(30);
                }
            })
            .catch(error => {
                showLoading(false);
                document.getElementById('username').disabled = false;
                toast.error("Error!");
            })
        }catch (error) {
            document.getElementById('username').disabled = false;
        }finally{
            showLoading(false);
        }
    };

    const onLogin = async (e) => {
        e.preventDefault();
        setBtnLoginStateDis(true);
        
        setPasscodeError(''); // Reset error message
        const passcode = document.getElementById("code").value;
        // Validate: Only numbers allowed
        if (!/^\d+$/.test(passcode)) {
            setPasscodeError('Passcode must contain only numbers.');
            return;
        }

        showLoading(true);
        try{
            // Assuming you have an API endpoint to verify the passcode
            await fetch(`${process.env.REACT_APP_API_URL}/cab/verifyPasscode`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': "*/*",
                    'Authorization': `Bearer ${getPassCode()}` // Passcode as Bearer token
                },
                body: JSON.stringify({
                    "email": encryptStr(username),  // Send email along for verification
                    "otp": encryptStr(document.getElementById("code").value)
                })
            })
            .then(response => {
                if(checkApiError(response.status)){ navigate("/login"); return; }
                // Check if the response status is OK (200)
                if (response.ok) {
                    return response.json(); // Parse JSON response
                } else {
                    //throw new Error('Invalid passcode'); // Throw error for other status codes
                }
            })
            .then(async data => {
                if(parseInt(data.isUserLock)){
                    // user lock for 2 min
                    setBtnResendStateDis(true);
                    setBtnLoginStateDis(true);
                    setIsUserLock(true);
                    setCodeInputDis(true);
                    document.getElementById('code').value = "";
                }else{
                    if(data.statusCode === 200){                        
                        if(await getAllTravelDetail()){
                            toast.success("Login success.");
                            toggleMenu(true);
                            showLoading(false);
                            setCurrentUser(data.attendee);
                            data.attendee.token = getPassCode();
                            onLoginContext(data.attendee, data.userRole);
                            isThisLoaded = false;
                        }
                        if (data.userRole === 1 || data.userRole === "1") {
                            checkAdmin(true);
                            navigate('/dashboard');
                            //getTravelDetail();
                        } else {
                            checkAdmin(false);
                            navigate('/Home');
                            //getAllTravelDetail();
                        }
                    }else{
                        showLoading(false);
                        setPasscodeError('Wrong Passcode entered. Please try again.');
                        document.getElementById("code").value = '';
                    }
                }
            })
            .catch(error => {
                showLoading(false);
                toast.error("Error!");
                //console.error(error);
                // Handle error, e.g., display an error message to the user
                //alert('Invalid passcode. Please try again.');
            });
        }catch(error){ }
    };
    const onEmailVal = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(document.getElementById("username").value)) {
            setIsEmailValid(false);
            return; // Don't proceed if email is invalid
        } else {
            setIsEmailValid(true); // Reset error state if email becomes valid
        }
    }

    const handleResend = async (e) => {
        setBtnResendStateDis(true);
        showLoading(true);
        e.preventDefault();
        // Assuming you have an API endpoint to resend the passcode
        try{
            await fetch(`${process.env.REACT_APP_API_URL}/cab/regeneratepasscode`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': "*/*"
                },
                body: JSON.stringify({
                    "email": encryptStr(username)
                })
            })
                .then(response => {
                    if(checkApiError(response.status)){ navigate("/login"); return; }
                    // Check if the response status is OK (200)
                    if (response.ok) {
                        return response.json(); // Parse JSON response
                    } else {
                        //throw new Error('Invalid passcode'); // Throw error for other status codes
                    }
                })
                .then(data => {
                    showLoading(false);
                    if (data.token) getPassCode(data.token.authToken);
                    toast.success("Passcode sent.");
                    setTimer(30);
                })
                .catch(error => {
                    showLoading(false);
                    toast.error('Error!');
                    //console.error(error));
                });
        }catch(error){ }
    };

    const changePwdType = (e) => {
        const pwdEle = document.getElementById('code');
        if(pwdEle.type === 'text'){            
            pwdEle.type = "password";
            setIsShowPwd(false);
        }else{
            pwdEle.type = "text";
            setIsShowPwd(true);
        }
    }

    const checkGetCodeBtnState = (e) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(document.getElementById("username").value)) {
            setBtnGetStateDis(false);
        } else {
            setBtnGetStateDis(true);
        }
    }

    const checkLoginBtnState = (e) => {
        const passcode = e.target.value; // document.getElementById("code").value;
        if (!/^\d+$/.test(passcode) && passcode !== "") {
            setPasscodeError('Passcode must contain only numbers.');
            e.target.classList.add('error-border');
            return;
        }else{
            e.target.classList.remove('error-border');
            setPasscodeError('');
        }

        if(passcode.length === 0){
            setBtnLoginStateDis(true);
            //setBtnResendStateDis(false);
        }else{
            setBtnLoginStateDis(false);
            //setBtnResendStateDis(true);
        }
    }

    const isMobile = detectDeviceType().toLowerCase() === 'mobile';
    return (
        <div style={{ height: '100%' }}>
            <img src={ImagesAll.OtherImages.LoginBg} className="cBgImage w3-image w3-display-middle" alt="Event Background"></img>
            <div className={`login-container w3-card-2 w3-container  w3-padding-large w3-padding-64 w3-white w3-round-large  ${isMobile ? 'w3-display-middle' : 'w3-display-middle'}`}>
                <div className={`logo ${isMobile ? "mobile" : ""}`}>
                    <img src={ImagesAll.Logos.EncoraBlack} className="cLogo" alt="Encora Logo"></img><div className="cCustomer roboto-medium fs-1-1">Customer<br></br>Advisory Board</div>
                </div>
                {username === "" && <form onSubmit={onGetCode} className="w3-padding w3-round-large">
                    <div className="w3-section">
                        <input
                            type="email"
                            id="username"
                            required
                            autoComplete="username"
                            className={`w3-input w3-border w3-round email-icon ${!isEmailValid ? 'error' : ''}`} // Add error class if needed
                            placeholder="Your Company Email"
                            onChange={checkGetCodeBtnState}
                        />
                        {!isEmailValid && <div className="error-message">Please enter a valid email address.</div>} {/* Error message */}
                    </div>
                    <button type="submit" className={`w3-button w3-block w3-theme w3-round ${btnGetStateDis ? 'w3-disabled' : ''}`}>Get Passcode</button>
                    { isUserLock ? (
                        <div className="cInstruction w3-margin-top">You have exceeded 5 attempts. Please refresh and try again after 2 minutes.</div>
                    ) : (
                        <div className="cInstruction w3-margin-top" style={{ 'opacity': '0' }}>An email containing Passcode has been sent to your registered email id.</div>
                    )}
                </form>}

                {username !== "" && <form onSubmit={onLogin} className="w3-padding w3-round-large">
                    <div className="w3-section p-relative">
                        <input
                            type="email"
                            value={username}
                            autoComplete="username"
                            className="w3-input w3-border w3-round email-icon"
                            readOnly
                            disabled
                        />
                        <div className='p-relative'>
                            <input
                                type="password"
                                id="code"
                                required
                                className="w3-input w3-border w3-round w3-margin-top lock-icon"
                                placeholder="Passcode"
                                maxLength={10}
                                autoComplete="current-password"
                                onChange={checkLoginBtnState}
                                disabled={codeInputDis}
                            />
                            <div className={`code-show-hide ${ !isShowPwd ? "eye-off-icon" : "eye-on-icon" }`} onClick={changePwdType}></div>
                        </div>
                        {passcodeError && <div className="error-message">{passcodeError}</div>} {/* Display error message */}
                    </div>
                    <button type="submit" className={`w3-button w3-block w3-theme w3-round ${btnLoginStateDis ? 'w3-disabled' : ''}`}>Log in</button>
                    <button type="button" onClick={handleResend} className={`w3-button w3-block w3-theme w3-round w3-margin-top ${btnResendStateDis ? 'w3-disabled' : ''}`}>Resend Passcode</button> {/* Resend button */}

                    <p className='small color-gray text-center mt-2'>00 : {timer === 0 ? '30' : timer < 10 ? '0'+timer : timer }</p>

                    { isUserLock ? (
                        <div className="cInstruction w3-margin-top">You have exceeded 5 attempts. Please refresh and try again after 2 minutes.</div>
                    ) : (
                        <div className="cInstruction w3-margin-top">An email containing Passcode has been sent to your registered email id.</div>
                    )}
                </form>}

                <div className='w3-padding page-instruction w3-padding-16'>Please don’t refresh the page once you are logged in.</div>
            </div>
        </div >
    );
};

export default Login;
